
<template>
    <div>Empty</div>
</template>


<script>

export default {
    components: {
    },
    props: {
    }
}
</script>
